import {Routes, UrlMatchResult, UrlSegment} from '@angular/router';
import {FuseLoginComponent} from '@modules/authentication/core/login/login.component';
import {BasicPageListAsCardsComponent} from 'fuse-core/components/basic-page/basic-page-list-as-cards/basic-page-list-as-cards.component';
import {FullPageComponent} from 'fuse-core/components/basic-page/full-page/full-page.component';
import {DefaultRouteComponent} from 'fuse-core/components/default-route/default-route.component';
import {HomePageComponent} from 'fuse-core/components/home-page/home-page.component';
import {InformationsLegalesComponent} from 'fuse-core/components/informations-legales/informations-legales.component';
import {IsAllowedBySettings, IsUserAnonymous, IsUserLogged} from '../../../../src/app/guards';
import {DemoChoiceComponent} from './demo/demo-choice/demo-choice.component';
import {DemoPlayerComponent} from './demo/demo-player/demo-player.component';
import {LoginComponent} from './authentication/login/login.component';
import {IackathonDeliverableListPageComponent} from './iackathon/pages/iackathon-deliverable-list-page/iackathon-deliverable-list-page.component';
import {IackathonGroupDetailsPageComponent} from './iackathon/pages/iackathon-group-details-page/iackathon-group-details-page.component';
import {IackathonGroupListPageComponent} from './iackathon/pages/iackathon-group-list-page/iackathon-group-list-page.component';
import {IackathonIntroPageComponent} from './iackathon/pages/iackathon-intro-page/iackathon-intro-page.component';
import {IackathonPageComponent} from './iackathon/pages/iackathon-page/iackathon-page.component';

const IACKATHON_ROUTES: Routes = [
    {
        path: 'iackathon',
        component: IackathonPageComponent,
    },
    {
        path: 'iackathon-intro',
        component: IackathonIntroPageComponent,
    },
    {
        path: 'iackathon-groups',
        component: IackathonGroupListPageComponent
    },
    {
        path: 'iackathon-groups/:id',
        component: IackathonGroupDetailsPageComponent
    },
    {
        path: 'iackathon-deliverables',
        component: IackathonDeliverableListPageComponent
    },
]

export const routes: Routes = [
    {
        path: '',
        component: DefaultRouteComponent,
        canActivate: [IsUserLogged, IsAllowedBySettings],
    },
    {
        path: 'home',
        component: HomePageComponent,
        canActivate: [IsUserLogged],
    },
    {
        path: 'further',
        canActivate: [IsUserLogged, IsAllowedBySettings],
        children: [
            {
                path: ':alias',
                component: HomePageComponent,
                canActivate: [IsAllowedBySettings],
            }
        ]
    },
    {
        title: 'aventure',
        path: 'page/aventure',
        component: FullPageComponent,
        canActivate: [IsUserLogged, IsAllowedBySettings]
    },
    {
        path: 'page/:alias',
        component: FullPageComponent,
        canActivate: [IsAllowedBySettings],
    },
    {
        path: 'informations-legales',
        component: InformationsLegalesComponent,
        canActivate: [IsAllowedBySettings],
    },
    {
        path: 'page-as-card-list/:alias',
        component: BasicPageListAsCardsComponent,
        canActivate: [IsAllowedBySettings],
    },
    {
        path: 'collection',
        canActivate: [IsAllowedBySettings],
        loadChildren: () => import('@fuse/components/collection/collection.module').then(m => m.CollectionModule),
    },
    {
        path: 'maintenance',
        loadComponent: () => import('../../../../src/app/maintenance/maintenance.component').then(m => m.MaintenanceComponent),
    },
    {
        path: 'groups',
        loadChildren: () => import('@modules/groups-management/core/groups-management.module').then(m => m.GroupsManagementModule),
        canActivate: [IsUserLogged] // Base guard, specific guards are in the child module
    },
    {
        path: 'followed', // Chemin pour accéder au module lazy-loadé
        loadChildren: () => import('@modules/assignation/core/assignation.module').then(m => m.AssignationModule),
        canActivate: [IsUserLogged] // Gardien appliqué avant le chargement
    },
    {
        path: 'login',
        component: LoginComponent,
        canActivate: [IsUserAnonymous]
    },
    {
        path: 'code',
        loadChildren: () => import('@modules/gamecode/core/gamecode.module').then(m => m.GamecodeModule)
    },
    {
        path: 'demo',
        children: [
            {
                path: '',
                component: DemoChoiceComponent,
            },
            {
                path: ':demoId',
                component: DemoPlayerComponent,
            },
        ],
    },
    ...IACKATHON_ROUTES,
];

export const routesWithLang: Routes = [
    ...routes,
    {
        matcher: langMatcher, // permit to add fr en or nl and route will watch without breaking existing route
        children: [
            ...routes
        ]
    },
];


export function langMatcher(segments: UrlSegment[]): UrlMatchResult {
    if (segments.length === 0) {
        return null;
    }

    const lang = segments[0].path;
    const allowed = ['fr', 'en', 'nl'];

    if (allowed.includes(lang)) {
        return {
            consumed: [segments[0]],
            posParams: {lang: segments[0]}
        };
    }

    return null;
}

